<template>
  <div>
    <div
      class="bg-primary-purple-50 w-full rounded-19 relative items-center overflow-hidden"
      :class="bannerPadding"
    >
      <div
        class="h-1/3 w-1/3 top-0 right-0 absolute border bg-warning-500 blur-2xl opacity-[11%]"
      ></div>
      <div
        class="h-1/4 w-1/4 top-[20%] right-[30%] absolute bg-primary-purple-500 blur-2xl opacity-[11%]"
      ></div>
      <div
        class="h-1/3 w-1/3 bottom-0 left-0 absolute bg-secondary-rose-500 blur-2xl opacity-[11%]"
      ></div>

      <div
        class="absolute h-3 w-3 rounded-full bg-primary-purple-400 left-3 sm:left-[3%] md:left-[4.7%] top-3 sm:top-[6%] md:top-[9%]"
      ></div>
      <div
        class="absolute"
        :class="[
          homePage
            ? 'left-[45%] top-3 sm:top-[8%] md:top-[5%] xl:top-[15%]'
            : 'left-[31%] top-1 xm:top-2 md:top-7 1.5xl:top-[17%]',
        ]"
      >
        <Icon icon="Polygon" />
      </div>
      <div
        class="absolute"
        :class="[
          homePage
            ? 'right-2 sm:right-[3%] md:right-[7%] lg:right-[13%] top-2 sm:top-[6%] lg:top-[8%] xl:top-[11.5%]'
            : 'right-[7%] xm:right-3 sm:right-[4%] bottom-[20%]',
        ]"
      >
        <Icon icon="Polygon-2" />
      </div>
      <div
        class="absolute h-3 w-3 rounded-full bg-secondary-blue-300"
        :class="[
          homePage
            ? 'right-[5%] sm:right-[10%] lg:right-[20%] xl:right-[25.5%]  bottom-[30%] lg:bottom-[25%] xl:bottom-[31%]'
            : 'right-[18%] bottom-2 md:bottom-[12%] lg:bottom-[14%]',
        ]"
      ></div>
      <div
        class="absolute h-4 w-4 md:h-6.5 md:w-6.5 rounded-full bg-warning-300"
        :class="[
          homePage
            ? 'right-[2%] xm:right-[6%] bottom-3 xm:bottom-[12%]'
            : 'right-3 sm:right-[9%] lg:right-[12%] top-3  lg:top-[14%]',
        ]"
      ></div>
      <div
        class="absolute rounded-full bg-secondary-blue-300 md:h-6.5 md:w-6.5 h-4 w-4"
        :class="[
          homePage
            ? 'left-[4%] md:left-[3%] lg:left-[6.5%] bottom-[43.5%]'
            : 'left-[7%] xm:left-3 sm:left-[7%] bottom-[11%]',
        ]"
      ></div>
      <div
        v-if="homePage"
        class="absolute left-2 xm:left-7 sm:left-[20%] md:left-[25%] bottom-1 sm:bottom-[5.5%] md:bottom-[3%] xl:bottom-[6%]"
      >
        <Icon icon="Polygon-3" />
      </div>
      <section>
        <div class="text-center">
          <div class="mb-6">
            <h1 v-if="Array.isArray(title)" class="flex flex-wrap justify-center">
              <span>
                {{ title[0] }}
                <span class="px-1 relative text-primary-purple-600 whitespace-nowrap">
                  {{ title[1] }}
                  <span
                    class="absolute inline xl:top-[70px] xl:left-2 lg:top-14 lg:-left-5 md:-left-12 md:top-11 top-8 -left-19"
                  >
                    <Icon icon="under" />
                  </span>
                </span>
                {{ title[2] }}
              </span>
            </h1>
            <h1 v-else>
              <span v-i18n="landingPage">{{ title }}</span>
            </h1>
          </div>
          <div class="px-6 md:px-8 lg:px-10 xl:px-12 1.5xl:px-[51.5px]">
            <p1 v-i18n="landingPage">{{ description }}</p1>
          </div>
        </div>
        <div v-if="btnClass" class="flex justify-center gap-5 mt-12.5" :class="btnClass">
          <button
            v-if="!showStartForFreeButton"
            class="bg-primary-purple-600 rounded-lg text-primary-purple-600 font-medium py-2 md:py-4 px-3 md:px-7 lg:text-lg leading-34 text-base tracking-normal flex items-center gap-3 z-[1]"
            @click="redirectToSignup"
          >
            <h5 class="whitespace-nowrap text-white">Start For Free</h5>
            <span><Icon icon="arrow-right-up" /></span>
          </button>
          <button
            v-if="!showRequestButton"
            class="bg-primary-purple-100 rounded-lg text-primary-purple-600 font-medium py-2 md:py-4 px-3 md:px-7 lg:text-lg leading-34 text-base tracking-normal flex items-center gap-3 z-[1]"
            type="button"
            @click="openCalendly"
          >
            <h5 class="whitespace-nowrap text-primary-purple-700">{{ btnText }}</h5>
            <span><Icon icon="arrow-right-up" color="primary-purple-700" /></span>
          </button>
        </div>
        <div v-if="showButton" class="flex justify-center gap-5 mt-12.5">
          <a
            :href="`${email?.href}${email?.subject}${email?.body}`"
            class="bg-primary-purple-600 rounded-lg text-primary-purple-600 font-medium py-2 md:py-4 px-3 md:px-7 lg:text-lg leading-34 text-base tracking-normal flex items-center gap-3 z-[1]"
          >
            <h5 v-i18n="landingPage" class="whitespace-nowrap text-white">BECOME_A_PARTNER</h5>
            <span><Icon icon="arrow-right-up" /></span>
          </a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Icon from '@src/components/icons/icon.vue'
import generalMixin from '@src/mixins/general-mixins.js'
import LoginMixin from '@src/mixins/signin-mixins.js'

export default {
  components: {
    Icon,
  },
  mixins: [generalMixin, LoginMixin],
  props: {
    homePage: {
      type: Boolean,
      default: false,
    },
    btnClass: {
      type: String,
      default: 'hidden',
    },
    title: {
      type: [String, Array],
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    email: {
      type: Object,
      default: () => {},
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    showStartForFreeButton: {
      type: Boolean,
      default: false,
    },
     showRequestButton: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: 'Request a Demo',
    },
  },
  data() {
    return {
      landingPage: 'landingPage',
    }
  },
  computed: {
    bannerPadding() {
      return this.homePage
        ? 'py-5 px-3 xm:py-7 sm:p-10 lg:p-15 xl:p-20 1.5xl:px-[80px] 1.5xl:py-[135px]'
        : 'p-5 sm:p-7 md:py-10 md:px-15 lg:py-17 lg:px-25 1.5xl:py-[93px] 1.5xl:px-[277px]'
    },
  },
  methods: {
    redirectToSignup() {
      this.$router?.currentRoute?.value?.fullPath.includes('quiz')
        ? this.redirectToQuizSignUp('app')
        : this.$router.push({
            name: 'signup',
          })
    },
    handleClick() {
      this.$emit('toggle-modal')
    },
    openCalendly() {
      window.open('https://calendly.com/myqampus-support/30min', '_blank')
    },
  },
}
</script>
